import { NgForOf } from '@angular/common';
import { Directive, Host, Input } from '@angular/core';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';

/**
 * ngForTrackByFields is a directive to be used in Angular *NgFor that will translate single string/Array of field to be NgForTrackBy function supported in native NgFor
 * *Samples*
 * Single ID
 ```html
 <div *ngFor="let item in items; trackByFields='id'"></div>
 OR
 <ng-template [ngFor]="let item in items" [ngForTrackByFields]="'id'">
   <div></div>
 </ng-template>

 ```
 *
 * Multiple Ids:
```html
<div *ngFor="let item in items; trackByFields: ['id','name']"></div>

<div *ngFor="let item in items; trackByFields: ['id','name']; trackByFieldsAny: true"></div>

OR
 
<ng-template [ngFor]="let item in items" [ngForTrackByFields]="['id','name']">
   <div></div>
 </ng-template>
 
 <ng-template [ngFor]="let item in items" [ngForTrackByFields]="['id','name']" ngForTrackByFieldsAny="true">
   <div></div>
 </ng-template>
```
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[ngForTrackByFields]'
})
export class NgForTrackByFieldsDirective<T>{
	@Input() public ngForTrackByFields: keyof T | Array<keyof T>;
	@Input() public ngForTrackByFieldsAny: boolean = false;
	constructor(@Host() private ngFor: NgForOf<T>) {
		this.ngFor.ngForTrackBy = (index: number, item: T) => {
			// first construct might not have value binding yet but the ngForTrackBy has to be define upon the element render
			// this won't cause an unnecessary round-trip as the first render, ngFor render every element anyways
			if (!this.ngForTrackByFields) {
				return item;
			}

			let fieldsValidAsId = false;
			if (this.ngForTrackByFields instanceof Array) {
				if (this.ngForTrackByFieldsAny) {
					fieldsValidAsId = !isEmpty(this.ngForTrackByFields) && this.ngForTrackByFields.some(field => get(item, field));
				} else {
					fieldsValidAsId = !isEmpty(this.ngForTrackByFields) && this.ngForTrackByFields.every(field => get(item, field));
				}
			} else {
				fieldsValidAsId = get(item, this.ngForTrackByFields);
				this.ngForTrackByFields = [this.ngForTrackByFields];
			}
			if (fieldsValidAsId) {
				return this.ngForTrackByFields.reduce((id, field) => id + get(item, field), '');
			} else {
				console.error('field', this.ngForTrackByFields, 'is not existed in type of', typeof item);
				return item;
			}
		};
	}
}
